import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
`;

export const Card = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  padding: 10px;
  min-width: ${(props) => (props.selected ? '790px' : '200px')};
  width: ${(props) => (props.selected ? '57%' : '17%')};
  height: ${(props) => (props.selected ? '350px' : '275px')};
  background: var(--cco-surface);
  border-radius: 12px;
  margin-bottom: 10px;
  transition: all 270ms;
  border: 1px solid
    ${(props) =>
      props.favorite ? 'var(--cco-orange)' : 'var(--cco-line)'};
  ${(props) =>
    props.selected && 'box-shadow: 0 0 0 1px var(--cco-blue-soft);'}

  img {
    cursor: pointer;
  }
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Checkbox = styled.div`
  width: 21px;
  height: 21px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid ${(props) => props.theme.colors.label};
  background: ${(props) =>
    props.selected ? props.theme.colors.label : 'transparent'};

  ::after {
    margin-left: 24px;
    line-height: 21px;
    content: 'Habilitado';
    font-weight: 900;
    font-size: 14px;
  }
`;

export const RangesWrapper = styled.div`
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  grid-template-columns: repeat(3, 1fr);
  column-gap: 5px;
  place-items: center;
  row-gap: 5px;
  color: var(--cco-ink-mute);
  text-align: center;
  transition: all 270ms;
  overflow: hidden;

  -webkit-animation: grow 270ms; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: grow 270ms; /* Firefox < 16 */
  -ms-animation: grow 270ms; /* Internet Explorer */
  -o-animation: grow 270ms; /* Opera < 12.1 */
  animation: grow 270ms;

  @keyframes grow {
    from {
      width: 0px;
      height: 0px;
    }
    to {
      width: 100%;
      height: auto;
    }
  }

  h3 {
    border-radius: 8px;
    font-size: 10px;
    color: var(--cco-ink-mute);
    background: var(--cco-soft-surface);
  }
  input {
    border-radius: 8px;
    color: var(--cco-ink);
    background: var(--cco-soft-surface);
    border: 1px solid var(--cco-line);
    max-width: 80px;
  }
`;

export const GraficoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 16px;
  padding: 3px 6px;
  cursor: pointer;
  border-radius: 50%;
  background: var(--cco-soft-surface);
  display: grid;
  place-items: center;

  ::after {
    content: 'x';
    font-size: 10px;
    color: var(--cco-ink-mute);
  }
`;

export const Button = styled.div`
  text-align: center;
  padding: 4px 16px;
  font-size: 14px;
  font-weight: 700;
  border: 1px solid var(--cco-blue);
  color: var(--cco-blue);
  border-radius: 8px;
  cursor: pointer;
  transition: all 270ms;
  :hover {
    background: var(--cco-blue);
    color: #fff;
  }
  ::after {
    content: '${(props) => props.label}';
  }
`;

export const Title = styled.label`
  font-size: 13px;
  text-align: center;
  font-weight: 800;
  color: var(--cco-ink);
`;

export const Tag = styled.div`
  display: flex;
  padding: 2px 14px;
  border-radius: 999px;
  font-size: 13px;
  color: #fff;
  background: ${(props) => props.theme.colors[props.color]};
  ${(props) =>
    props.clickable &&
    `
    cursor: pointer;
  :hover {
    transform: scale(1.05);
  }`}
`;

export const Input = styled.input`
  text-align: center;
  padding: 3px 7px;
  color: var(--cco-ink);
`;

export const RangeTitle = styled.h3`
  text-align: center;
  color: ${(props) => props.color};
`;

export const Level = styled.label`
  color: ${(props) => props.theme.colors.label};
  font-size: 14px;
  text-align: center;
`;

export const ElevatedValue = styled.div`
  border-radius: 10px;
  font-size: 18px;
  display: flex;
  background: var(--cco-soft-surface);
  color: var(--cco-ink);
  padding: 5px 15px;
  width: 150px;
  text-overflow: ellipsis;
  border: 1px solid var(--cco-line);
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input {
    width: 100%;
  }
`;

export const Period = styled(Tag)`
  width: auto;
  padding: 5px 20px;
  cursor: pointer;
  font-size: 14px;
  color: ${(props) => (props.selected ? '#fff' : 'var(--cco-ink-mute)')};
  transition: all 270ms;

  ${(props) =>
    props.selected
      ? `background: ${
          props.color === 'blue' ? 'var(--cco-blue)' : 'var(--cco-orange)'
        };`
      : `background: var(--cco-soft-surface)`}

  :hover {
    ${(props) =>
      `background: ${
        props.color === 'blue' ? 'var(--cco-blue)' : 'var(--cco-orange)'
      };`}
    color: #fff;
  }
`;

export const HistoricIconWrapper = styled.button`
  padding: 10px;
  transition: transform 270ms;
  background: transparent;
  transform: scale(1);
  :hover {
    transform: scale(1.09);
  }
  img {
    :hover {
      transform: scale(1.09);
    }
  }
`;

export const HistoricGraphWrapper = styled.div`
  display: flex;
`;

export const HistoricInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 20%;
  margin: 0 35px;
  justify-content: space-evenly;
`;

export const HistoricTimelineWrapper = styled.div`
  flex: 4;
  display: flex;
  flex-direction: column;
  max-height: 58vh;
  overflow-y: auto;
`;

export const HistoricTimelineCell = styled.div`
  display: flex;
  position: relative;
  border-left: 1px solid rgba(0, 0, 0, 0.5);
  margin-left: 10px;
  padding-left: 30px;
  height: 100px;
  ::before {
    content: '.';
    color: transparent;
    top: 5px;
    left: -6px;
    width: 11px;
    height: 11px;
    position: absolute;
    border-radius: 50%;
  background: ${(props) =>
    props.company
      ? props.theme.colors.orange
        : props.theme.colors.blue};
  }
`;

// export const HistoricCellColumn = styled.div`
export const HistoricCellColumn = styled.div`
  display: flex;
  flex-direction: column;
  h3,
  span,
  label {
    line-height: 20px;
  }
  h3 {
    color: var(--cco-ink-mute);
    font-size: 16px;
  }
  span {
    font-size: 18px;
    font-weight: 900;
    color: var(--cco-ink);
  }
  label {
    color: var(--cco-blue);
    font-size: 15px;
    font-weight: 800;
  }
`;

export const HistoricCellTag = styled.div`
  margin: 20px;
  background: ${(props) =>
    props.company
      ? props.theme.colors.orange
      : props.theme.colors.blue};
  width: 40px;
  height: 15px;
  border-radius: 10px;
`;
